












import { Component, Vue } from 'vue-property-decorator';
import LeafletsModlue from '@/store/modules/leaflets';

@Component
export default class QRCode extends Vue {
  // QRコード用のPDFのURL
  private pdf: string | null = null;

  // QRコードのサイズ
  private qrcodeSize = 200;

  // ストアアクションの購読解除関数
  private unsubscribe?: Function;

  activated() {
    this.pdf = LeafletsModlue.pdf;

    // モジュール監視
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'leaflets/setIndex') {
        this.pdf = LeafletsModlue.pdf;
      }
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  deactivated() {
    this.unsubscribe && this.unsubscribe();
    window.removeEventListener('resize', this.handleResize);
  }

  /**
   * ウィンドウに基づいて新しいキャンバスサイズを計算する
   */
  private handleResize() {
    this.qrcodeSize = Math.floor(this.$el.clientHeight * (234 / 400));
  }
}
